<template>
  <div class="container money-page" >
    <div class="container-flex">
    <pi-balance-block
        :accountObj="accountObj"
        btnName="余额明细"
        @btnClick="gotoTargetRoute('record')"
      ></pi-balance-block>
    </div>
    <div class="btn-box">
      <pi-button block type="primary" @click="gotoTargetRoute('recharge')">立即充值</pi-button>
      <pi-button block type="text" class="refund" @click="gotoTargetRoute('account-refund')">申请退款</pi-button>
    </div>
  </div>
</template>

<script>
import { getUserAccount } from "../../common/api";
import balanceBlock from "@/components/pi-balance-block/pi-balance-block.vue";
export default {
  name: "money",
  components: {
    [balanceBlock.name]: balanceBlock,
  },
  data() {
    return {
      money: "-",
      accountPkId: null,
      accountObj: {},
    };
  },
  mounted() {
    this.accountPkId = this.$route.query.accountPkId;
    this.getUserAccountList();
  },
  methods: {
    goMoneyTips() {
      this.$router.push("/money-tips");
    },
    getUserAccountList() {
      //获取获取账号信息
      let that = this;
      getUserAccount(null, false)
        .then((response) => {
          if (
            response.status == that.$config.ajaxStatus &&
            response.data.length > 0
          ) {
            this.accountObj = response.data[0];
            this.accountPkId = this.accountObj.accountPkId;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    gotoTargetRoute(name) {
      this.$router.push({
        name: name,
        // query: {
        //   accountPkId: this.accountPkId,
        // },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.money-page{
  padding: 0.2rem;
  .refund{
    margin-top: 0.08rem;
  }
}

</style>
